<template>
  <myDialog :isDialog="isShowSjypzAdd" title="创建数据源" @handleClose="$emit('handleClose')">
    <template slot="content">
      <el-form ref="cjsjyForm" :model="cjsjyForm" label-width="120px">
        <el-form-item label="数据库名字">
          <el-input v-model="cjsjyForm.name" placeholder="请输入数据库名字"></el-input>
        </el-form-item>
        <div class="cjsjyContent">
          <div class="cjsjyLeft cjsjyContentItem">
            <div class="contentTitle">
              <span>数据库类型</span>
            </div>
            <div class="contentList">
              <div class="contentListItem" @click="sjkClick(item,index)" :class="sjkLxActive==index?'contentListItemActive':''" v-for="(item,index) in sjkTypeList" :key="index">
                <div>
                  <img :src="item.icon" alt="">
                  <span>{{item.name}}</span>
                </div>
                <img :style="sjkLxActive==index?'opacity: 1;':'opacity: 0;'" src="@/assets/images/sys/drpz/success-icon.png" alt="">
              </div>
            </div>
          </div>
          <div class="cjsjyRight cjsjyContentItem">
            <div class="contentTitle">
              <span>设置</span>
            </div>
            <div class="contentList">
              <el-form-item label="主机名称">
                <el-input v-model="cjsjyForm.name" placeholder="请输入主机名称"></el-input>
              </el-form-item>
              <el-form-item label="数据库名称">
                <el-input v-model="cjsjyForm.name" placeholder="请输入数据库名称"></el-input>
              </el-form-item>
              <el-form-item label="端口号">
                <el-input v-model="cjsjyForm.name" placeholder="请输入端口号"></el-input>
              </el-form-item>
              <el-form-item label="用户名">
                <el-input v-model="cjsjyForm.name" placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input v-model="cjsjyForm.name" placeholder="请输入密码"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </template>
    <template slot="footer">
      <div class="cancelBtn" @click="$emit('handleClose')">测试</div>
      <div class="cancelBtn" @click="$emit('handleClose')">确定</div>
    </template>
  </myDialog>
</template>

<script>
export default {
  props: {
    isShowSjypzAdd: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sjkLxActive:0,
      cjsjyForm:{
        name:'',
      },
      sjkTypeList:[
        {
          name:'MySQL',
          icon: require('@/assets/images/sys/drpz/MySQL-icon.png'),
        },
        {
          name:'Oracle',
          icon:require('@/assets/images/sys/drpz/Oracle-icon.png'),
        },
      ],
    };
  },
  mounted() {
    
  },
  methods: {
    sjkClick(item,index){
      this.sjkLxActive = index;
    }
  },
};
</script>

<style lang="scss" scoped>
.cjsjyContent{
  display: flex;
  .cjsjyContentItem{
     height: 50vh;
    .contentTitle{
      color: #2a3347;
      font-weight: 500;
      font-size: 14px;
      padding-top: 16px;
      padding-bottom: 12px;
      border-bottom: 1px solid #BBD9FB;
      >span{
        padding-left: 8px;
        border-left: 2px solid #0C7BF2;
      }
    }
    .contentList{
      padding: 16px 12px;
      height: calc(100% - 48px);
      overflow: auto;
      .contentListItem{
        cursor: pointer;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 42px;
        border-radius: 3px;
        border: 1px solid #0c7bf24d;
        background: #ffffff;
        margin-top: 8px;
        &:first-child{
          margin-top: 0;
        }
        &::before{
          content: '';
          display: block;
          width: 24px;
          height: 24px;
        }
        >div{
          display: flex;
          justify-content: center;
          align-items: center;
          >img{
            width: 50px;
            height: 26px;
            margin-right: 8px;
          }
          >span{
            color: #2a3347;
            font-weight: 500;
            font-size: 14px;
          }
        }
        >img{
          float: right;
          width: 24px;
          height: 24px;
        }
      }
      .contentListItemActive{
        border: 1px solid #44D0BE;
      }
    }
  }
  .cjsjyLeft,.cjsjyRight{
    border-radius: 5px;
    background: #fcfcfc;
  }
  .cjsjyLeft{
    width: 280px;
  }
  .cjsjyRight{
    flex: 1;
    margin-left: 16px;
    /deep/.el-form-item{
      margin-bottom: 8px;
    }
  }
}
/deep/.el-form-item__label{
  padding: 0 24px 0 0;
}
</style>
